export default function getAppUserData() {
    return {
        uidSlave: localStorage.getItem('uidSlave'),
        userId: localStorage.getItem('userID'),
        username: localStorage.getItem('username'),
        role: localStorage.getItem('role'),
        selectedMainHotel: localStorage.getItem('selectedMainHotel'),
        selectedParityHotel: localStorage.getItem('selectedParityHotel'),
        mainHotelsSectionData: JSON.parse(localStorage.getItem('mainHotelsSectionsData')),
        features: JSON.parse(localStorage.getItem('features')),
        hasFtp: JSON.parse(localStorage.getItem('hasFTP')),
        email: localStorage.getItem('email'),
        lookerUrl: JSON.parse(localStorage.getItem('lookerUrl')),
        priceByNight: localStorage.getItem('priceByNight'),
        language: localStorage.getItem('language'),
    }
}

// USER.company is free text with mixed case ('w2m', 'W2M'): same normalisation as the backend (normalize_company)
export function isW2mCompany(company) {
    return (company || '').trim().toLowerCase() === 'w2m'
}
